import * as React from "react";
import { Correction, MiscCorrection } from '../Request/DcfRequestReducer';
import { CorrectionPreview } from './CorrectionsPreview';
import { useReferenceContextProvider } from "../../Core/ReferenceContextProvider"

export interface CorrectionPreviewPanelProps {
    correctionType: string;
    corrections: Correction[];
    miscCorrection: MiscCorrection;
}

export const CorrectionPreviewPanel = (props: CorrectionPreviewPanelProps): JSX.Element => {
    const { dcfTypes } = useReferenceContextProvider();

    if (props.corrections.length === 0 && props.miscCorrection === null) {
        return null;
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <div className="row">
                            <div className="col-md-4"><h3 className="panel-title">Data Correction - {dcfTypes.find(d => d.id === props.correctionType)?.name ?? "Miscellaneous"}</h3></div>
                            <div className="col-md-4"><h3 className="panel-title text-left">From</h3></div>
                            <div className="col-md-4"><h3 className="panel-title">To</h3> </div>
                        </div>
                    </div>
                    <div className="panel-body">
                        <CorrectionPreview {...props} />
                    </div>
                </div>
            </div>
        </div>
    );
}
